module.exports = __webpack_public_path__ + "static/media/sound_project.d145ed26.jpg";